import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getGMPHideColumnsAPI = createApi("GMPGetHideColumns","GET");

const GMPGetHideColumns = createSlice({
  name: 'GMPGetHideColumns',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGMPHideColumnsAPI.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getGMPHideColumnsAPI.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getGMPHideColumnsAPI.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GMPGetHideColumns.reducer;